import { useMemo } from 'react'

import {
  SpaceNotificationPreference,
  MemberSpaceNotificationSettings,
  SpaceDefaultNotificationSettings,
} from '@tribeplatform/gql-client/types'
import { I18nShape, T, useI18n } from '@tribeplatform/react-components/i18n'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { Checkbox } from '@tribeplatform/react-ui-kit/Checkbox'
import { Select } from '@tribeplatform/react-ui-kit/Select'

import { MemberNotificationSettingOptions } from './utils'

const getTextByValue = (
  intl: I18nShape,
  value?: SpaceNotificationPreference | null,
): string => {
  switch (value) {
    case SpaceNotificationPreference.ALL:
      return intl.$t({
        defaultMessage: 'All activity (new posts & replies)',
        id: 'Notification.AllActivity',
      })
    case SpaceNotificationPreference.NEW_POST:
      return intl.$t({
        defaultMessage: 'New posts',
        id: 'Generics.NewPosts',
      })
    case SpaceNotificationPreference.NONE:
      return intl.$t({
        defaultMessage: 'Posts of Interest',
        id: 'Notification.PostsOfInterest',
      })
    default:
      return ''
  }
}
export const NotificationPreferencesChannelOverride = ({
  defaultValue,
  notificationSettings,
  onChange,
}: {
  defaultValue: SpaceNotificationPreference
  notificationSettings:
    | SpaceDefaultNotificationSettings
    | MemberSpaceNotificationSettings
    | null
    | undefined
  onChange: (
    sameAsDefault: boolean,
    newValue: SpaceNotificationPreference | null | undefined,
  ) => void
}) => {
  const intl = useI18n()
  const { data: network } = useNetwork()
  const memberNotificationSettings = useMemo(() => {
    return MemberNotificationSettingOptions(intl)
  }, [intl])
  const hasEmail =
    network?.settings?.emailEnabled &&
    network?.settings?.emailNotificationEnabled
  const value = notificationSettings?.preference ?? defaultValue
  if (!hasEmail) {
    return null
  }
  return (
    <div>
      <Checkbox
        checked={!notificationSettings?.sameAsDefault}
        onChange={() => {
          onChange(!notificationSettings?.sameAsDefault, value)
        }}
      >
        <T
          defaultMessage="Use different settings for email notifications"
          id="Notification.Preference.EmailOverride.Checkbox"
        />
      </Checkbox>
      {!notificationSettings?.sameAsDefault && (
        <Select
          className="ms-6 mt-3"
          value={value}
          onChange={preference => {
            onChange(false, preference)
          }}
        >
          <Select.Button>{getTextByValue(intl, value)}</Select.Button>
          <Select.Items>
            {memberNotificationSettings.map(option => (
              <Select.Item key={option.value} value={option.value}>
                {option.label}
              </Select.Item>
            ))}
          </Select.Items>
        </Select>
      )}
    </div>
  )
}
